// Base configuration for all environments
const config = {
  development: {
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001'
  },
  production: {
    API_BASE_URL: 'https://gallery.globe-groupe.com' // Empty string for relative paths in production
  },
  test: {
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001'
  }
};

// Get current environment, fallback to 'development' if not set
const env = process.env.NODE_ENV || 'development';

// Export the configuration for the current environment
export const API_BASE_URL = config[env].API_BASE_URL;
export const BASE_URL_IMAGE_VIEWER = 'https://stpublicclient.blob.core.windows.net/teamhaven/Pictures/';

// Connect's public URL as seen by the browser — SSO logout and keep-alive calls
// must come from the browser (the cookie belongs to Connect's domain).
export const CONNECT_UI_URL = process.env.REACT_APP_CONNECT_UI_URL || 'https://connect.globe-groupe.com';

// The app's own identity, not configuration: the same client_id in every
// environment, preview deployments included. A second copy in the env only
// created a way for it to drift from the backend's CONNECT_CLIENT_ID.
export const CONNECT_CLIENT_ID = 'gallery';

// The parent app embedding Gallery in an iframe: target of the "reconnect" button
// when the SSO session is dead. A login form is never rendered inside a frame.
export const PARENT_APP_URL = process.env.REACT_APP_PARENT_APP_URL || 'https://cockpit.globe-groupe.com';

// Clé localStorage du jeton de session du flux fournisseur externe (primer-impacto).
// Clé DÉDIÉE : l'ancien emplacement partagé `authToken` est celui de l'auth Basic
// legacy, purgé au montage — un jeton rangé là serait effacé.
export const SESSION_TOKEN_KEY = 'gallerySessionToken';

// Attributs du cookie legacy `authToken` — ne servent plus qu'à sa PURGE :
// la suppression doit viser le même domaine que la pose.
export const COOKIE_DOMAIN = process.env.REACT_APP_COOKIE_DOMAIN || '.globe-groupe.com';
export const COOKIE_SECURE = process.env.NODE_ENV === 'production'; // true en production, false en développement

// You can add more configuration exports here if needed
export default {
  API_BASE_URL
};
